export const createSha256Base64 = async (
  data: string,
  secret: string,
): Promise<string> => {
  const enc = new TextEncoder()
  const algorithm = { name: 'HMAC', hash: 'SHA-256' }
  const key = await crypto.subtle.importKey(
    'raw',
    enc.encode(secret),
    algorithm,
    false,
    ['sign', 'verify'],
  )
  const signature = await crypto.subtle.sign(
    algorithm.name,
    key,
    enc.encode(data),
  )
  return btoa(String.fromCodePoint(...new Uint8Array(signature)))
}
